export default function FeaturesSection() {
  const features = [
    { title: 'Smart Data Structuring', desc: 'Easier decision-making through logically organized information', icon: 'ri-stack-line' },
    { title: 'Fast Access System', desc: 'Find what you need instantly and save hours every single day', icon: 'ri-flashlight-line' },
    { title: 'Clean Interface', desc: 'No clutter, no confusion — just pure clarity and focused design', icon: 'ri-contrast-line' },
    { title: 'Scalable Layout', desc: 'Works equally well for beginners and power users handling volume', icon: 'ri-expand-diagonal-line' },
    { title: 'Workflow Tracking', desc: 'Monitor every step of your purchasing process with precision', icon: 'ri-git-branch-line' },
    { title: 'Comparison Tools', desc: 'Analyze supplier options side-by-side to make smarter choices', icon: 'ri-scales-3-line' },
  ];

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Key Features
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            What Makes Itaobuy Spreadsheet Different
          </h2>
          <p className="mt-4 text-foreground-600 text-base md:text-lg max-w-xl mx-auto">
            Built with workflow intelligence, not just cells and formulas. Every feature is designed around real purchasing needs.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-6 md:p-7 rounded-xl bg-background-100 border border-background-200 hover:border-primary-200 transition-all duration-300"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600 group-hover:bg-primary-100 transition-colors duration-300">
                <i className={`${feat.icon} text-lg`}></i>
              </span>
              <h3 className="mt-4 text-lg font-heading font-bold text-foreground-900">
                {feat.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}